import React from 'react'
import { AlertWrapper, AlertIcon, AlertContent } from './styles'

const iconMap = {
  success: '\u2713',
  error: '\u2715',
  warning: '\u26A0',
  info: '\u2139',
}

export const AlertBanner = ({ severity = 'info', children }) => (
  <AlertWrapper $severity={severity}>
    <AlertIcon>{iconMap[severity] || '\u2139'}</AlertIcon>
    <AlertContent>{children}</AlertContent>
  </AlertWrapper>
)
